import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { InviteExtendedListResponse, InviteQueryParams } from '@frontend/user/types';

export class InviteExtendedClient extends APIClient {
    public static readonly endpoint = '/user-api/ext/v1';

    public static async fetchInvitesExtended(queryParams?: ApiQueryParams<InviteQueryParams>): Promise<InviteExtendedListResponse> {
        return await this.apiPaginated<InviteExtendedListResponse, InviteQueryParams>(`${this.endpoint}/invites`, queryParams);
    }
}
